/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import _findIndex from 'lodash/findIndex';
import logNewRelicCustom from '../../../utils/logNewRelicCustom';
import { NEW_RELIC_EVENTS } from '../../../constants';

export default (set, get, sku) => set(
  produce(
    get(),
    (draft) => {
      const updateExisting = _findIndex(get().design.cart, ['Sku', sku]);

      if (!draft.design) {
        draft.design = {};
      }

      if (updateExisting !== -1) {
        draft.design.cart[updateExisting].Quantity += 1;
      } else {
        draft.design.cart.push({
          Sku: sku,
          Quantity: 1
        });
      }

      draft.design.selectedProduct = null;

      // logging
      logNewRelicCustom(NEW_RELIC_EVENTS.NON_VISUALIZED_PRODUCT_ADDED, get().design.cart);
    }),
  false,
  { type: 'ADD', payload: {} }
);
